<div [style.background]="imageVisible && backgroundColor" #wrapper>
  @if (safeImgDataUrl) {
    <img
      #sourceImage
      class="source-image"
      [src]="safeImgDataUrl"
      alt="img to crop"
      [style.visibility]="imageVisible ? 'visible' : 'hidden'"
      [style.transform]="safeTransformStyle"
      (load)="imageLoadedInView()" />
  }
  <div
    class="overlay"
    [style.width.px]="maxSize.width"
    [style.height.px]="maxSize.height"
    [style.margin-left]="alignImage === 'center' ? marginLeft : null"></div>
  @if (imageVisible) {
    <div
      class="cropper"
      [class.rounded]="roundCropper"
      [style.top.px]="cropper.y1"
      [style.left.px]="cropper.x1"
      [style.width.px]="cropper.x2 - cropper.x1"
      [style.height.px]="cropper.y2 - cropper.y1"
      [style.margin-left]="alignImage === 'center' ? marginLeft : null"
      [style.visibility]="imageVisible ? 'visible' : 'hidden'"
      (keydown)="keyboardAccess($event)">
      <div
        (mousedown)="startMove($event, moveTypes.MOVE)"
        (touchstart)="startMove($event, moveTypes.MOVE)"
        class="move">
      </div>
        <span
          class="resize topleft"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'topleft')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'topleft')">
          <span class="square"></span>
        </span>
        <span class="resize top">
          <span class="square"></span>
        </span>
        <span
          class="resize topright"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'topright')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'topright')">
          <span class="square"></span>
        </span>
        <span class="resize right">
          <span class="square"></span>
        </span>
        <span
          class="resize bottomright"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'bottomright')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'bottomright')">
          <span class="square"></span>
        </span>
        <span class="resize bottom">
          <span class="square"></span>
        </span>
        <span
          class="resize bottomleft"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'bottomleft')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'bottomleft')">
          <span class="square"></span>
        </span>
        <span class="resize left">
          <span class="square"></span>
        </span>
        <span
          class="resize-bar top"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'top')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'top')">
        </span>
        <span
          class="resize-bar right"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'right')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'right')">
        </span>
        <span
          class="resize-bar bottom"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'bottom')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'bottom')">
        </span>
        <span
          class="resize-bar left"
          (mousedown)="startMove($event, moveTypes.RESIZE, 'left')"
          (touchstart)="startMove($event, moveTypes.RESIZE, 'left')">
        </span>
    </div>
  }
</div>
